import React from "react";
import Navbar from "../../components/Layout/Navbar";
import Footer from "../../components/Layout/Footer";
import TitleAndDate from "../../components/TitleAndDate";
import logoungegn from "../../assets/UNGEGN.png";

function AboutAsed() {
  return (
    <>
      <Navbar />
      <div className="container mx-auto px-20">
        <div className="mt-6 mb-6">
          {/* <h4 className="text-xl font-semibold mb-2">
            ABOUT UNGEGN ASIA SOUTH-EAST DIVISION (ASE DIVISION)
          </h4> */}
          <TitleAndDate title="ABOUT UNGEGN ASIA SOUTH-EAST DIVISION (ASE DIVISION)" />
          {/* <p>{formattedDate}</p> */}
        </div>

        <div className="mb-8 text-center">
          <img
            src={logoungegn}
            alt="UNGEGN"
            className="mx-auto h-auto max-w-md mb-4"
          />
          <p className="text-justify leading-relaxed">
            The United Nations Group of Experts on Geographical Names (UNGEGN),
            Asia South-East and Pacific South-West Division was originally set
            up in 1972 as Asia South-East Division in accordance with the second
            United Nations Conference on the Standardisation of Geographical
            Names (UNCSGN) Resolution II/4, which was held in London. During the
            Ninth United Nations Regional Cartographic Conference (UNRCC) for
            Asia and the Pacific held in Wellington, it was recommended that the
            Division should be enlarged and renamed as Asia South-East and
            Pacific South-West. Subsequently this recommendation was adopted
            during the Fifth Divisional Meeting in Bogor, Indonesia in October
            1980 which was chaired by Malaysia and attended by Indonesia,
            Malaysia and the Philippines. The Fifth Divisional Meeting Report
            was submitted at the Ninth UNGEGN Session, New York, 17-27 February
            1981 and listed as Working Paper No.5.
            <br />
            <br />
            At the Sixth Asia, South-East and Pacific South-West Divisional
            Meeting from 29 to 30 September 1992 held in Wellington, New
            Zealand, Mr. Vern O'Brian, an expert from Australia proposed to
            change the name from a geographic division to a linguistics division
            as "Austronesia" Division of UNGEGN. Other members suggested to keep
            the geographic division as the "Asia, South-East and the Pacific"
            (delete the word south-west) or (Asia, south-east and Pacific,
            central-south), or just "Pacific Asia". The Sixth Divisional Meeting
            Report was submitted at the Seventeenth Session of UNGEGN held in
            New York from 13-14 June 1994, as Working Paper no. 70, in which the
            name of "Austronesian" Division might be appropriate the cover the
            languages of Asia, South-East and Pacific, South-West.
            <br />
            <br />
            The reasons of changing name of the division was presented in the
            respective Report of theDivision: quote: "In considering languages
            in the majority of countries of South East Asia, north and east of
            Australia, the AUSTRONESIAN language family has been used as a name,
            which has also been called the Malayo-Polynesian family in most
            English dictionaries in Australia. It seems logical that a language
            group name of the major countries in the area -Austronesian - could
            also be applied to a Division of UNGEGN in this region, comprising
            the major group of countries and inclusive of Australia, which gains
            its name from TERRA AUSTRALIS applied by Mathew Flinders in 1814.
            The group also includes Melanesia, Micronesia and in the West:
            Indonesia, Malaysia, etc." unquote.
            <br />
            <br />
            The current name of Asia, South-East and Pacific, South-West, has
            already been used baut historically, no UNCSGN Resolution addressed
            the existence of this Division. In the final/closing report of the
            Seventeenth UNGEGN Session, item no. 233, stated the following
            statement, quote "The Secretary addressed the request of the Asia,
            South-East and Pacific, South-West Division to drop the word
            "South-West" from the name. This would be decided at the next
            session of UNGEGN", unquote.
            <br />
            <br />
            During the Eighteenth Divisional Meeting United Nations Group of
            Experts on Geographical Names, Asia South-East and Pacific
            South-West attended by five (5) member countries from Philippine,
            Indonesia, Singapore, Brunei Darussalam and Malaysia which was held
            in Kuala Lumpur Malaysia on 22th February 2011, it was proposed that
            the Division should be split into two, namely Asia South-East
            Division (to include Sri Lanka and Bhutan) and Pacific South-West
            Division. This decision was taken in particular due to the long
            distance between the two regions therefore most of the Pacific
            South-West countries are unable to attend Ita annual meeting.
            <br />
            <br />
            An informal meeting was held at the UN Vienna Office during the
            Twenty-Sixth Session of the United Nations Group of Experts on
            Geographical Names on 4 May 2011 where six (6) ember countries from
            Indonesia, Philippines, Australia, New Zealand, Sri Lanka and
            Malaysia attended this meeting which was chaired by Malaysia. The
            Meeting took the position that the membership of the Division could
            only be decided after obtaining the views of all member countries of
            the Division. This refers to the proposed resolution of the meeting
            in Kuala Lumpur to split the Division into two groups.
            <br />
            <br />
            This matter was again raised at the recent Nineteenth Divisional
            Meeting United Nations Groupof Experts on Geographical Names, Asia
            South-East and Pacific South-West, which was held inManila,
            Philippines on 28 February 2012. During the Nineteenth Meeting the
            five (5) attending member countries (Indonesia, Brunei Darussalam,
            Singapore, Malaysia and Philippine) agreed to split the division
            subject to the approval of the majority of the member countries. The
            meeting agreed to get the response from other member countries which
            had not attended the meeting. Should there be no response received
            from those countries by end of April 2012, then it can be considered
            as agreeable to the splitting of the Division.
            <br />
            <br />
            Malaysia had written a letter to all member countries to vote for or
            against the proposal with a clause stating that "Should there be no
            response received from any member countries by And 5 of April 2012,
            then it will be considered as agreeable to the splitting of the
            Division." Until the dateline only Vietnam and Papua New Guinea have
            responded and agreed to the proposal to split the Division into two.
            <br />
            <br />
            This means that seven (7) countries had expressed their supports for
            the proposal. The other sixteen (15) countries have not responded on
            the proposal which when taken into account thesaid clause in the
            letter sent to these countries, will meant that they also agreed to
            the proposal.
            <br />
            <br />
            With this outcome, this Division wish to present the proposal to
            split the Division into two (2) during this upcoming UNGEGN and
            UNCSGN for consideration and approval as follows; I. Asia South-East
            Division which include member countries from Brunei Darussalam,
            Bhutan, Cambodia, Indonesia, Lao People's Democratic Republic,
            Malaysia, Myanmar, Philippine, Singapore, Sri Lanka, Thailand, and
            Vietnam (12 countries). II. and Pacific South-West Division which
            include member countries from Australia, Fiji, Nauru, New Zealand,
            Papua New Guinea, Samoa, Solomon Islands, Timor-Leste, Tonga and
            Vanuatu (10 countries).
            <br />
            <br />
            In accordance to UNGEGN's rule that a country shall decide for
            itself the division to which Ir wishes to belong and may be a member
            of another division provided the nature of Ita participation does
            not change the linguistic/geographical character of the division(s)
            concerned, member countries from this division including Bhutan
            (also member of India Division), Lao People's Democratic Republic
            (also member of French Speaking Division), Timor Leste (also member
            of Portuguese speaking division) and New Zealand (also member of
            United Kingdom Division) too become member of other divisions as
            well.
            <br />
            <br />
            Currently this division with twenty two (22) member countries has
            the largest number of members compare to other divisions under
            UNGEGN. With the split of the division, decisions taken during the
            divisional meeting which on average attended by five (5) member
            countries, could be translated into actions since consultations and
            consensus would be easier and therefore faster. Currently, major
            decisions taken by attending member countries will have to refer to
            alk 22 member countries for approval making it difficult and even
            impossible to implement. It is therefore believed that the split
            will give better impetus to the activities of geographic naming for
            all countries involved in both regions.
            <br />
            <br />
            During the informal meeting held in United Nations office in Vienna
            on 4 May 2011, the Division agreed with the recommendation made by
            Ms. Helen Kerfoot, Chair of UNGEGN that in the event of the split,
            projects, including regional map and gazetteer should remain as
            Joint project. The regional map and gazetteer will continuously be
            updated with the help of both Australia and New Zealand. The
            cooperation between these two regions will continue and anak perhaps
            will conduct joint meetings and trainings between the divisions.
            <br />
            <br />
          </p>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default AboutAsed;
